import React from 'react';
import { Button } from '@material-ui/core';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { LocalDataTrack } from 'twilio-video';

export default function RemotePrintButton() {
  const { room } = useVideoContext();

  const handleClick = () => {
    const localDataTrack = Array.from(room?.localParticipant.tracks.values() || []).find(
      pub => pub.track?.kind === 'data'
    )?.track as LocalDataTrack | undefined;

    if (!localDataTrack) {
      alert('[⚠️ RemotePrintButton] localDataTrack não encontrado');
      return;
    }

    localDataTrack.send(
      JSON.stringify({
        comando: 'tirar_foto',
      })
    );
  };

  return (
    <Button onClick={handleClick} startIcon={<PhotoCameraIcon style={{ color: '#707578' }} />}>
      Tirar foto remota
    </Button>
  );
}
